import xhrWrapper from './xhrWrapper';
import {log as logToServer} from '../api/logger';

const nativeExperimentsRequest = (global.window && global.window.ha && global.window.ha.experimentsRequest) || null;

// TODO: if/when this client-side experiment fetch ever becomes a core part of the app (i.e., not just for visitors in variant 1 of the caching test),
// we should assign a rejected promise to `experimentsPromise` when `nativeExperimentsRequest` so that an error is logged to the backend (similar to what we're doing in the csrfTokenHelper.js)
const experimentsPromise = nativeExperimentsRequest
    ? xhrWrapper(nativeExperimentsRequest)
    : Promise.resolve("{}");

// register a catch handler so we can log any errors that occur during experiments resolution to the backend
experimentsPromise.catch((err) => {
    logToServer({
        message: 'Experiments promise resolution failed',
        error: err.toString()
    });
});

/**
 * Returns a promise that's resolved with the Abacus bucketing results token after the `window.ha.experimentsRequest` XHR request has completed.
 *
 * @returns {Promise<string|null>}
 */
async function getExperiments() {
    const response = await experimentsPromise;
    const jsonResponse = JSON.parse(response);

    return jsonResponse;
}

export default getExperiments;
export {
    getExperiments
};
